import { faFacebook, faInstagram, faLinkedinIn, faXTwitter, faThreads, faTiktok } from "@fortawesome/free-brands-svg-icons";
import { WrapperComponent, SocialSidebar, AdCard, ListArticleCard } from '../../../_imports.js';
import Links from '../../../../constants/links';
import './blog_post_body.css';

function BlogPostBody({ post, relatedPosts, isRecruiter }) {
    return (
        <WrapperComponent>
            <div className="blog-content-layout">

                {/* Social Sidebar */}
                <SocialSidebar
                    icons={[
                        { href: Links.instagram, icon: faInstagram, label: "Instagram" },
                        ...(isRecruiter ? [
                            { href: Links.x, icon: faXTwitter, label: "X" },
                            { href: Links.linkding, icon: faLinkedinIn, label: "LinkedIn" }
                        ] : [
                            { href: Links.tiktok, icon: faTiktok, label: "TikTok" },
                            { href: Links.facebook, icon: faFacebook, label: "Facebook" },
                            { href: Links.threds, icon: faThreads, label: "Threads" }
                        ]),
                        // { href: Links.youtube, icon: faYoutube, label: "YouTube" }
                    ]}
                    hoverClass={isRecruiter ? 'recruiter-socials' : 'candidate-socials'}
                />

                {/* Article Content */}
                <article className="blog-post-container">
                    <header className="post-header">
                        <h1 className="post-title">{post.title}</h1>
                        <p className="post-subtitle">{post.description}</p>
                        <div className="post-meta">
                            <span>Por {post.author}</span> | <span>{post.date}</span>
                        </div>
                    </header>

                    {(post.youtubeUrl && post.youtubeUrl.includes('http')) && (
                        <div className="post-video-container">
                            <iframe
                                src={post.youtubeUrl}
                                title={post.title}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    )}

                    <div className="post-content">
                        {post.contentes && post.contentes.map((section, index) => (
                            <div key={index} className="post-section">
                                {section.subtitle && <h3 className="post-section-title">{section.subtitle}</h3>}
                                {section.text && <p className="post-section-text">{section.text}</p>}
                            </div>
                        ))}
                    </div>

                    {(post.referencias && post.referencias.length > 0) && (
                        <div className="post-reference">
                            <h4>Referências:</h4>
                            <ul className="references-list">
                                {post.referencias.map((ref, index) => {
                                    const link = post.linkReferencias && post.linkReferencias[index];
                                    return (
                                        <li key={index}>
                                            {link ? (
                                                <a href={link} target="_blank" rel="noopener noreferrer">
                                                    {ref || "Fonte"}
                                                </a>
                                            ) : (
                                                <span>{ref}</span>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    )}

                    {/* SUGGESTED READS SECTION */}
                    {relatedPosts.length > 0 && (
                        <div className="suggested-reads-section">
                            <h3 className="suggested-title">Sugestões de próximas leituras</h3>
                            <div className="suggested-grid">
                                {relatedPosts.slice(0, 4).map(p => (
                                    <ListArticleCard key={p.id} post={p} />
                                ))}
                            </div>
                        </div>
                    )}
                </article>

                {/* PURPLE: Ads Sidebar */}
                <aside className="ads-sidebar">
                    <AdCard />
                    <AdCard />
                    <AdCard />
                </aside>
            </div>
        </WrapperComponent>
    );
};

export default BlogPostBody;
